<template lang="pug">
    v-card(v-if="!hideNoResults || filteredTelefonliste.length" :flat="hideNoResults")
      v-card-title(v-if="!hideNoResults")
        | Telefonliste
        v-alert(type="error" :value="error")
        v-spacer
        .shrink.pr-3: v-checkbox(label="Wallstr." v-model="zentrale" hide-details)
        v-text-field(append-icon="search" label="Suche" single-line hide-details v-model="search")
      v-card-title.title(v-else)
        v-icon(color="black") group
        | &nbsp; Suchergebnisse &nbsp;
        router-link(to="/telefonliste") Personen
      template(v-if="$vuetify.breakpoint.smAndDown")
        v-layout(v-if="!hideNoResults")
          v-flex: v-autocomplete(clearable label="Funktion" :items="funktionen" item-text="name" item-value="id" v-model="funktion" multiple dense solo flat)
          v-flex: v-autocomplete(clearable label="Projekt" :items="filteredProjekte" item-text="name" item-value="id" v-model="projekt" multiple dense solo flat)
          v-flex: v-autocomplete(clearable label="Bereich" :items="bereiche" item-text="name" item-value="id" v-model="bereich" multiple dense solo flat)
            template(slot="item" slot-scope="{ item }")
              v-list-tile-content
                v-list-tile-title(v-text="item.name")
                v-list-tile-sub-title(v-text="item.pnr")
          v-flex: v-autocomplete(clearable label="Abteilung" :items="abteilungen" item-text="name" item-value="id" v-model="abteilung" multiple dense solo flat)
          v-flex: v-autocomplete(clearable label="Leitungskräfte" :items="positionen" item-text="name" item-value="id" v-model="position" multiple dense solo flat)
        v-data-table(must-sort no-data-text="keine daten" no-results-text="keine passenden daten" :items="filteredTelefonliste" :headers="headers" :loading="loading" :pagination.sync="pagination" :rows-per-page-items="rowsPerPage" rows-per-page-text="Pro Seite:")
          template(slot="headers" slot-scope="props")
            tr
              th(v-for="header in props.headers.filter(h => h.value === 'vorname' || h.value === 'nachname')" :key="header.text" :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']" @click="changeSort(header.value)")
                | {{ header.text }}
                v-icon(small) arrow_upward
          template(slot="items" slot-scope="props")
            tr(@click="props.expanded = !props.expanded")
              td(colspan="2" class="py-2")
                .user-thumb-round(v-if="props.item.thumb" :style="`background-image: url(${props.item.thumb})`")
                div: strong {{ props.item.titel }} {{ props.item.nachname }} {{ props.item.vorname }}
                div(v-if="props.item.email") E-Mail: {{ props.item.email }}
                div(v-if="props.item.telefon") Tel: {{ props.item.telefon }}
                div(v-if="props.item.mobil") Mobil: {{ props.item.mobil }}
                div(v-if="props.item.fax") Fax: {{ props.item.fax }}
                div(v-if="props.item.funktion") Funktion: {{ props.item.funktion }}
                div {{ props.item.projekte_flat }}
                div(v-if="props.item.bereiche.length") Bereich: {{ props.item.bereiche.join(", ") }}
                div {{ props.item.abteilungen_flat }}
                div
                  span(v-if="props.item.vorstand")  Vorstand
                  span(v-if="props.item.staebe_referenten")  Stäbe/Referenten
                  span(v-if="props.item.abteilungsleitung")  Abteilungsleitung
                  span(v-if="props.item.bereichsleitung")  Bereichsleitung
                  span(v-if="props.item.projektleitung")  Projektleitung
      template(v-else)
        v-data-table(must-sort no-data-text="keine daten" no-results-text="keine passenden daten" :items="filteredTelefonliste" :headers="headers" :loading="loading" :pagination.sync="pagination" :rows-per-page-items="rowsPerPage" rows-per-page-text="Pro Seite:")
          template(slot="headers" slot-scope="props")
            tr
              th
              th(v-for="header in props.headers.filter(h => h.sortable !== false)" :key="header.text" :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']" @click="changeSort(header.value)")
                | {{ header.text }}
                v-icon(small) arrow_upward
              template(v-if="!hideNoResults")
                th
                  v-autocomplete(clearable label="Funktion" :items="funktionen" item-text="name" item-value="id" v-model="funktion" multiple dense solo flat)
                th
                  v-autocomplete(clearable label="Projekt" :items="filteredProjekte" item-text="name" item-value="id" v-model="projekt" multiple dense solo flat)
                    template(slot="item" slot-scope="{ item }")
                      v-list-tile-content
                        v-list-tile-title(v-text="item.name")
                        v-list-tile-sub-title {{item.pnr}}
                th
                  v-autocomplete(clearable label="Bereich" :items="bereiche" item-text="name" item-value="id" v-model="bereich" multiple dense solo flat)
                th
                  v-autocomplete(clearable label="Abteilung" :items="abteilungen" item-text="name" item-value="id" v-model="abteilung" multiple dense solo flat)
                th
                  v-autocomplete(clearable label="Leitungskräfte" :items="positionen" item-text="name" item-value="id" v-model="position" multiple dense solo flat)
              template(v-else)
                th Projekt
                th Abteilung
                th Leitungskräfte
          template(slot="items" slot-scope="props")
            tr(@click="props.expanded = !props.expanded")
              td: .user-thumb-round(v-if="props.item.thumb" :style="`background-image: url(${props.item.thumb})`")
              td {{ props.item.titel }}
              td {{ props.item.nachname }}
              td {{ props.item.vorname }}
              td {{ props.item.email }}
              td {{ props.item.telefon }}{{ props.item.telefon && props.item.mobil ? ", " : "" }}{{ props.item.mobil }}
              td {{ props.item.fax }}
              td {{ props.item.funktion }}
              td {{ props.item.projekte_flat }}
              td {{ props.item.bereiche.join(", ") }}
              td {{ props.item.abteilungen_flat }}
              td
                span(v-if="props.item.vorstand")  Vorstand
                span(v-if="props.item.staebe_referenten")  Stäbe/Referenten
                span(v-if="props.item.abteilungsleitung")  Abteilungsleitung
                span(v-if="props.item.bereichsleitung")  Bereichsleitung
                span(v-if="props.item.projektleitung")  Projektleitung

          template(slot="pageText" slot-scope="props")
            v-menu.mr-3(v-if="!hideNoResults" top offset-y open-on-hover)
              v-btn(slot="activator" icon)
                v-icon vertical_align_bottom
              v-list
                v-list-tile(@click="downloadCsv"): v-list-tile-title Download CSV
                v-list-tile(@click="downloadVcards"): v-list-tile-title Download vCard
                v-list-tile(@click="downloadClipboard"): v-list-tile-title In Zwischenablage Kopieren
            span {{props.pageStart}} - {{props.pageStop}} von {{props.itemsLength}}

</template>

<style lang="stylus" scoped>
.comma-list:not(:last-of-type):after
  content ", "
.input-group--single-line
  min-width 130px
  max-width 250px
.datatable
  th, td
    vertical-align middle
.btn
  padding 0
.user-thumb-round
  border-radius 50%
  width 40px
  height 40px

</style>

<script>
import vCardJS from 'vcards-js'
import stringify from 'csv-stringify/lib/sync'
import { writeText } from 'clipboard-polyfill'

function findBy(key, valueToFind) {
  return function(item) {
    return item[key] === valueToFind
  }
}
function sortBy(key) {
  return function(a, b) {
    if (a[key] > b[key]) {
      return 1
    } else if (a[key] < b[key]) {
      return -1
    } else {
      return 0
    }
  }
}
function mapProjectId(id) {
  return this.projekte.find(findBy('id', id)) || { id: id }
}
function onlyUnique(value, index, self) { 
    return self.indexOf(value) === index;
}
function uniq(array) {
  return array.filter(onlyUnique)
}
function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

export default {
  props: {
    extra: Object,
    query: String,
    per: Number,
    hideNoResults: Boolean,
    hideEmptySearch: Boolean,
    count: Number,
  },
  data() {
    Promise.all([
      this.$http.get('/api/v1b/projekte').then( r => r.json() ),
      this.$http.get('/api/v1b/telefonliste?q[status_eq]=angestellt&q[art_eq]=mitarbeiter').then( r => r.json() )
    ]).then(([projekte, telefonliste]) => {
      this.projekte = projekte.sort(sortBy('name'))
      let abteilungen = []
      let funktionen = []
      let bereiche = []
      telefonliste.forEach( (person) => {
        person.projekte = person.projekt_ids.map(mapProjectId, this)
        person.projekte.forEach(p => {
          if (p.personal_schluessel) {
            p.pnr = `P${p.personal_schluessel}`
          }
        })
        person.projekte_flat = person.projekte.map(p => `${p.name} ${p.pnr ? `(${p.pnr})` : ''}`).sort().join(', ')
        person.abteilungen = uniq(person.projekte.map(p => p.abteilung)).sort()
        person.abteilungen.forEach(a => {
          if (a && ! abteilungen.find(aa => a === aa.id)) {
            abteilungen.push({ name: a, id: a })
          }
        })
        funktionen.push(person.funktion)
        let person_bereiche = person.projekte.map(p => p.bereich)
        person_bereiche.push(person.bereich)
        person.bereiche = uniq(person_bereiche).filter(b => b).sort()
        bereiche = bereiche.concat(person.bereiche)
        person.abteilungen_flat = person.abteilungen.join(', ')
      })
      this.funktionen = uniq(funktionen).filter(f => f).sort().map(f => ({ name: f, id: f }))
      this.bereiche = uniq(bereiche).filter(b => b).sort().map(b => ({ name: b, id: b }))
      this.abteilungen = abteilungen.sort(sortBy('id'))
      this.telefonliste = telefonliste
      this.loading = false;
    }).finally(_ => {
      if (this.loading) {
        this.loading = false
        this.error = 'Laden Fehlgeschlagen';
      }
    });
    return {
      headers: [
        { text: '', sortable: false },
        { text: 'Titel', value: 'titel' },
        { text: 'Nachname', value: 'nachname' },
        { text: 'Vorname', value: 'vorname' },
        { text: 'E-Mail', value: 'email' },
        { text: 'Telefon', value: 'telefon' },
        { text: 'Fax', value: 'fax' },
        { text: 'Projekte', sortable: false },
        { text: 'Funktion', sortable: false },
        { text: 'Bereich', sortable: false },
        { text: 'Abteilung', sortable: false }
      ],
      positionen: [
        { name: 'Vorstand', id: 'vorstand' }, 
        { name: 'Stäbe/Referenten', id: 'staebe_referenten' },
        { name: 'Abteilungsleitung', id: 'abteilungsleitung' },
        { name: 'Bereichsleitung', id: 'bereichsleitung' },
        { name: 'Projektleitung', id: 'projektleitung' },
      ],
      pagination: { sortBy: 'nachname', descending: false, perPage: this.per },
      funktionen: [],
      funktion: [],
      bereiche: [],
      bereich: [],
      telefonliste: [],
      projekte: [],
      abteilungen: [],
      projekt: [],
      abteilung: [],
      position: [],
      search: '',
      zentrale: false,
      loading: true,
      error: null,
    };
  },
  computed: {
    rowsPerPage() {
      const per = this.per
      const items = [25, 50, 100, 500, { text:'Alle', value: -1 }]
      if (per && per !== -1 && items.indexOf(per) === -1) {
        items.unshift(per)
      }
      return items
    },
    filteredTelefonliste() {
      var telefonliste = this.telefonliste

      if (this.zentrale) {
        telefonliste = telefonliste.filter(t => t.projekte.some(p => p.standort && p.standort.aussenstelle === 'HVD-AS-00'))
      }

      if (this.funktion.length) {
        var funktion = this.funktion
        telefonliste = telefonliste.filter(t => funktion.some(f => t.funktion === f))
      }

      if (this.bereich.length) {
        var bereich = this.bereich
        telefonliste = telefonliste.filter(t => t.bereiche.some(ber => bereich.some(b => ber === b)))
      }

      if (this.projekt.length) {
        var projekt = this.projekt
        telefonliste = telefonliste.filter(t => t.projekte.some(p => projekt.some(pp => pp === p.id)))
      }

      if (this.abteilung.length) {
        var abteilung = this.abteilung
        telefonliste = telefonliste.filter(t => t.abteilungen.some(abt => abteilung.some(a => abt === a)))
      }

      if (this.position.length) {
        var position = this.position
        telefonliste = telefonliste.filter(t => position.some(p => t[p]))
      }

      const search = this.hideNoResults ? this.query : this.search

      if (search) {
        var p_parts = []
        var parts = search.split(/\s+/).filter(p => p).map(p => {
          const pnr = p.match(/^[Pp](\d+)$/)
          if (pnr) {
            p_parts.push(new RegExp(`^${escapeRegExp(p)}$`, 'i'))
            return null
          } else {
            return new RegExp(escapeRegExp(p), 'i')
          }
        }).filter(p => p)
        var filter = function(t) {
          var fields = [t.vorname, t.nachname, t.email, t.telefon, t.fax]
          return parts.every(p => fields.find(f => f && p.test(f))) && (!p_parts.length || p_parts.every(pp => t.projekte.find(p => pp.test(p.pnr))))
        }
        telefonliste = telefonliste.filter(filter)
      } else if (this.hideEmptySearch) {
        return []
      }
      
      this.$emit('update:count', telefonliste.length)
      return telefonliste
    },
    filteredProjekte() {
      var projekte = this.projekte

      if (this.abteilung.length) {
        var abteilung = this.abteilung
        projekte = projekte.filter(p => abteilung.some(a => p.abteilung === a))
      }

      return projekte
    }
  },
  watch: {
  },
  methods: {
    changeSort (column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    downloadName() {
      let name = ["HVD"]
      if (this.abteilung.length) {
        const abteilung = this.abteilungen.filter(abt => this.abteilung.some(a => abt.id === a))
        name.push(abteilung.map(a => a.name).join(" "))
      }
      if (this.projekt.length) {
        const projekt = this.projekte.filter(pro => this.projekt.some(p => pro.id === p))
        if (projekt.length) {
          name.push(projekt.map(p => p.name).join(" "))
        }
      }
      if (this.position.length) {
        const position = this.positionen.filter(pos => this.position.some(p => pos.id === p))
        if (position.length) {
          name.push(position.map(p => p.name).join(" "))
        }
      }
      const search = this.hideNoResults ? this.query : this.search
      if (search) {
        name.push(search)
      }
      return name.join(' ')
    },
    downloadCsv() {
      const list = this.filteredTelefonliste.filter(t => t.email).map(t=> [t.titel, t.nachname, t.vorname, t.email])
      const data = stringify(list, { delimiter: ';' })
      this.download(this.downloadName(), 'csv', 'text/csv', data)
    },
    downloadVcards() {
      const name = this.downloadName()
      const vCard = vCardJS()
      vCard.organization = name
      vCard.workEmail = this.filteredTelefonliste.filter(t => t.email).map(t => t.email)
      this.download(name, 'vcf', 'text/vcard', vCard.getFormattedString())
    },
    downloadClipboard() {
      writeText(this.filteredTelefonliste.filter(t => t.email).map(t => t.email).join("; "))
    },
    download(name, ext, type, content) {
      const url = window.URL.createObjectURL(new Blob([content], { type }))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `${name.replace(/[^a-z0-9äüöß_ -]+/gi, '-').replace(/-+/, '-').replace(/^-+|-+$/g, '')}.${ext}`)
      document.body.appendChild(link)
      link.click()
    }
  }
}
</script>
